import React from 'react'
import styles from '../Viewer.module.scss'
import {AnimatePresence, motion} from 'framer-motion'
import MultiMatrixCell from './MultiMatrixCell'
import EmptyData from '../../EmptyData/EmptyData'
import {constants} from '../viewModeConstants'
import 'react-tooltip/dist/react-tooltip.css'

function MultiMatrix({
                         weight,
                         viewMode,
                         cellsData,
                         isTrainer,
                         isNormalize,
                         indentStyle,
                         // equityLine,
                         moveMode,
                         selectedCell,
                         selectedCellsFunc,
                         viewModeOnePlayer,
                         setSelectedCellMode,
                         isSmallTrainerMatrix,
                         strategyFilters,
                         viewModeTwoPlayers,
                         isSettings,
                         eqrMax,
                     }) {
    let height = !isTrainer && ''

    if (viewMode === constants.TWO_PLAYER) {
        if (viewModeTwoPlayers === 'eq') {
            height = 'calc(100% - 65px)'
        } else {
            height = 'calc(100% - 43px)'
        }
    }

    const heightForMac = !isTrainer && viewModeOnePlayer === constants.STRATEGY ? styles.matrix_changeHeight : ''

    return (
        <>
            <table
                className={[styles.matrix, indentStyle, heightForMac].join(' ')}
                style={{
                    height,
                    transition: viewMode === constants.TWO_PLAYER ? 'none' : '',
                    borderCollapse: isTrainer && 'collapse',
                }}
            >
                {viewModeOnePlayer === constants.DIFF_EV &&
                viewMode === constants.ONE_PLAYER &&
                strategyFilters.activeActions.length === 0 ? (
                    <EmptyData text='Please choose an action to view ΔEV'/>
                ) : (
                    <tbody>
                    {cellsData &&
                        cellsData.map((tr, index) => (
                            <AnimatePresence key={index}>
                                <motion.tr initial={{opacity: 0}} animate={{opacity: 1}} exit={{opacity: 0}}>
                                    {tr.map((el) => {
                                        return (
                                            <MultiMatrixCell
                                                el={el}
                                                key={el.cellIndex}
                                                weight={weight}
                                                moveMode={moveMode}
                                                viewMode={viewMode}
                                                isTrainer={isTrainer}
                                                isNormalize={isNormalize}
                                                selectedCell={selectedCell}
                                                selectedCellsFunc={selectedCellsFunc}
                                                setSelectedCellMode={setSelectedCellMode}
                                                isSmallTrainerMatrix={isSmallTrainerMatrix}
                                                isSettings={isSettings}
                                                eqrMax={eqrMax}
                                            />
                                        )
                                    })}

                                </motion.tr>
                            </AnimatePresence>
                        ))}
                    </tbody>
                )}
            </table>
        </>
    )
}

export default React.memo(MultiMatrix)
